import React, { useEffect, useState } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { useQlik } from "../context/Qlik";
import { useFilterBar } from "../context/FilterBar";
import { useLeftBar } from "../context/LeftBar";
import { useConfig } from "../context/Config";
import Overview from "./Overview/Overview";
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";
import "../style.scss";
import BaseCovarage from "./BaseCovarage/BaseCovarage";
import PCandSkin from "./PCendSKIN/PCandSkin";
import DigitalChannels from "./DigitalChannels/DigitalChannels";
import PointsTop from './PointsTop/PointsTop'

function Layout() {
  const { qlik, qlikConfig, setActualApp } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { leftBarOpened } = useLeftBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);
    }
  }, [qlik, qlikConfig, setActualApp]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [qlik]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <Header />
        <FilterMenu
          app={app}
          filters={config?.app?.filters || {}}
          config={config}
        />
        <div className="container-app">
          <LeftSideMenu app={app} config={config} />

          <Switch>
            <Route exact path="/">
              <Redirect to="/overview" />
            </Route>
            <Route
              path="/overview"
              exact
              render={() => <Overview app={app} config={config} />}
            />
            <Route
              path="/base-covarage"
              exact
              render={() => (
                <BaseCovarage app={app} config={config} />
              )}
            />

            <Route
              path="/pc-skin"
              exact
              render={() => (
                <PCandSkin app={app} config={config} />
              )}
            />

            <Route
              path="/digital-channels"
              exact
              render={() => <DigitalChannels app={app} config={config} />}
            />

            <Route
              path="/points-top-10"
              exact
              render={() => <PointsTop app={app} config={config} />}
            />
          </Switch>
        </div>
      </HashRouter>
    </div>
  );
}

export default Layout;
